import { IPriceResponseEventMetrics } from './interface';
const getZeroEventMetrics = () => ({
    count: 0,
    hours: 0,
    days: 0,
});

export const calculateTotalEventsMetrics = (metrics: IPriceResponseEventMetrics[]) => {
    const result = getZeroEventMetrics();

    if (!metrics) {
        return result;
    }

    metrics.forEach(metricItem => {
        result.count += metricItem.count;
        result.hours += metricItem.hours;
        metricItem.count > 0 && (result.days += 1);
    });

    return result;
};
